module.exports = __webpack_public_path__ + "static/media/gallery_11_thumb.153be49f.jpg";